<template>
  <card>
    <template slot="header">
      <div style="float: right">
        <base-button v-if="loggedUser.role === UserRoles.ADMIN" type="primary" size="lg" class="btn-fill mr-2" v-on:click="downloadEvaluations">
          Download evaluations
        </base-button>
        <base-button v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN" type="warning" size="lg" class="btn-fill" v-on:click="exportFinalRanking">
          Export ranking
        </base-button>
      </div>
      <h2 class="card-title">{{$t('documents.list')}}</h2>
    </template>
    <div class="row">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <div>
            <tabs ref="tab-calls" type="info" square>
              <tab-pane :id="call.name" :label="call.title" v-for="call in calls" v-bind:key="call.id">
                <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                  <div>
                    <el-select class="filter-select mr-2" v-if="loggedUser.role === UserRoles.ADMIN" v-model="filters.regionId" placeholder="Filter by region" clearable @change="handleFilters">
                      <el-option v-for="item in filterOptions.regions" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.applicationStatus" placeholder="Filter by status" clearable @change="handleFilters">
                      <el-option v-for="item in filterOptions.application_statuses" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.objectives" multiple collapse-tags placeholder="Filter by objectives" clearable @change="handleFilters">
                      <el-option v-for="item in filterOptions.objectives" :key="item.value" :label="$t(item.text) + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                    <el-select class="filter-select mr-2" v-model="filters.evaluationStatus" placeholder="Filter by evaluation status" clearable @change="handleFilters">
                      <el-option v-for="item in filterOptions.evaluation_statuses" :key="item.value" :label="item.text + ' ('+item.total+')'" :value="item.value"/>
                    </el-select>
                  </div>
                </div>

                <el-table :data="call.proposals">
                  <el-table-column
                    label="Reference Nr"
                    property="reference"
                    prop="reference"
                  ></el-table-column>
                  <el-table-column
                    label="Name"
                    property="user.name"
                    prop="user.name"
                  ></el-table-column>
                  <el-table-column
                    label="Organization"
                    property="user.organization"
                    prop="user.organization"
                  ></el-table-column>
                  <el-table-column
                    label="Region"
                    property="region"
                    prop="region.name"
                  ></el-table-column>
                  <el-table-column
                    label="Documents Uploaded"
                    property="total_documents"
                    prop="total_documents"
                  >
                  </el-table-column>
                  <el-table-column
                    label="Admissibility Eligibility Check"
                    property="admissibility"
                    prop="admissibility"
                  >
                  </el-table-column>
                  <el-table-column
                    label="Status"
                    property="application_status"
                    prop="application_status"
                  >
                    <div slot-scope="props">
                      <span v-if="props.row.evaluation_status === 'Rejected'" class="badge badge-danger">{{props.row.evaluation_status}}</span><br />
                      <span v-if="props.row.evaluation_status !== 'Rejected'" class="badge badge-success">{{props.row.evaluation_status}}</span><br />
                      <span>{{props.row.application_status}}</span>
                    </div>
                  </el-table-column>
                  <el-table-column align="right" label="Actions">
                    <div slot-scope="props">
                      <base-button
                        type="info"
                        size="sm"
                        class="mb-1 mr-2"
                        @click="view(props.row)"
                      >
                        View Documents
                      </base-button>
                      <base-button
                        class="mb-1"
                        type="warning"
                        size="sm"
                        @click="evaluateApplicationModal(props.row)"
                      >
                        <i class="tim-icons icon-paper"></i> Evaluate
                      </base-button>
                    </div>
                  </el-table-column>
                </el-table>
                <div
                  slot="footer"
                  class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                >
                  <div class="">
                    <p class="card-category">
                      Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                    </p>
                  </div>
                  <base-pagination
                    class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="total"
                  >
                  </base-pagination>
                </div>
              </tab-pane>
            </tabs>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="modalEvaluate.visibility" headerClasses="justify-content-center">
      <h4 slot="header" class="title">Evaluate documents: <strong>{{modalEvaluate.documents.reference_nr}}</strong>
      </h4>
      <ol>
        <li>
          <span v-if="modalEvaluate.documents.summaries && modalEvaluate.documents.summaries.length > 0 || (loggedUser.role === UserRoles.EVALUATOR)" class="pl-1 link-text"> Screening Report </span>
          <a v-if="(modalEvaluate.documents.summaries && modalEvaluate.documents.summaries.length === 0) && (loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN)" @click="evaluateSummary(modalEvaluate.documents)" class="pl-1 link-text"> Screening Report </a>
          <ul class="evaluations-list">
            <li v-for="summary in modalEvaluate.documents.summaries" :key="summary.id">
              <span>
                <a v-if="summary.writable" @click="evaluateSummaryById(summary.id)" class="pl-1 link-text"> {{summary.status}} </a>
                <span v-if="!summary.writable" class="pl-1 link-text"> {{summary.status}} </span>
                ({{summary.evaluator.name}})<br/>
                (Submitted at: {{summary.submitted_at}})<br/>
                (Updated at: {{summary.updated_at}})
              </span>
            </li>
          </ul>
        </li>
        <li>
          <span v-if="modalEvaluate.documents.summaries && (modalEvaluate.documents.summaries.length === 0 || modalEvaluate.documents.summaries[0].admissibility !== 'accepted') || (loggedUser.role !== UserRoles.EVALUATOR)" class="pl-1 link-text"> Evaluation Grid </span>
          <a v-if="modalEvaluate.documents.summaries && modalEvaluate.documents.summaries.length > 0 && modalEvaluate.documents.summaries[0].admissibility === 'accepted' && (loggedUser.role === UserRoles.EVALUATOR)" @click="evaluateSummaryGrid(modalEvaluate.documents)" class="pl-1 link-text"> Evaluation Grid </a>
          <ul class="evaluations-list">
            <li v-for="grid in modalEvaluate.documents.grids" :key="grid.id">
              <span>
                <a @click="evaluationGridSummary(grid.id)" class="pl-1 link-text"> {{grid.status}} </a>
                ({{grid.evaluator.name}})<br/>
                (Submitted at: {{grid.submitted_at}})<br/>
                (Updated at: {{grid.updated_at}})
              </span>
            </li>
          </ul>
        </li>
      </ol>

      <div class="row">
        <div class="col-8 mt-2">
          <el-select class="filter-select mr-2 mb-2" v-model="modalEvaluate.documents.evaluation_status" placeholder="Choose evaluation status" clearable @change="changeEvaluationStatus">
            <el-option v-for="item in evaluationStatuses" :key="item" :label="item" :value="item"/>
          </el-select>
          <span>(Updated at: {{modalEvaluate.documents.evaluation_status_updated_at}})</span>
        </div>
        <div class="col-4 mt-2 text-right">
          <base-button
            type="danger"
            @click.native="modalEvaluate.visibility = false"
          >Close
          </base-button>
        </div>
      </div>
    </modal>

  </card>
</template>
<script>
  import {Table, TableColumn, Select, Option} from 'element-ui';
  import {Modal, TabPane, Tabs} from 'src/components';
  import {BasePagination} from 'src/components';
  import Fuse from 'fuse.js';
  import {ProposalService, CallService, DocumentService, SummaryService, UserRoles, RegionService} from "@/services";

  export default {
    components: {
      TabPane,
      Tabs,
      BasePagination,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Modal
    },
    computed: {
      /***
       * Returns a page from the searched data or the whole data. Search is performed in the watch section below
       */
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      }
    },
    data() {
      return {
        pagination: {
          perPage: 10000,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        calls: [],
        searchQuery: '',
        tableData: [],
        searchedData: [],
        fuseSearch: null,
        initialized: false,
        UserRoles,
        loggedUser: {},
        modalEvaluate: {
          visibility: false,
          documents: {}
        },
        regions: [],
        evaluationStatuses:
        [
          'Rejected',
          'Preselected',
          'Selected'
        ],
        filterOptions: [],
        filters: {
          regionId: undefined,
          applicationStatus: undefined,
          objectives: undefined
        },
      };
    },
    methods: {
      async getItems()
      {
        let vm = this;
        let loader = vm.$loading.show();

        await vm.getCalls();
        await vm.getProposals();

        loader.hide();
      },
      async getCalls()
      {
        let vm = this;

        await CallService.all().then((response) =>
        {
          vm.calls = response.data;
        });
      },
      async getProposals()
      {
        let vm = this;

        for (let i = 0; i < vm.calls.length; i++)
        {
          await ProposalService.getProposals({
            call_id: vm.calls[i].id,
          }).then((response) =>
          {
            vm.calls[i].proposals = response.data;
          });
        }
      },
      view(data) {
        this.$router.push('/proposals/fill/' + data.proposal_type_id + '/' + data.id);
      },
      evaluateApplicationModal(documents) {
        let vm = this;
        vm.modalEvaluate.visibility = true;
        vm.modalEvaluate.documents = documents;
      },
      evaluateSummary(documents) {
        if (documents) {
          if (documents.summaries.length === 0) {
            SummaryService.createSummaryReport({
              user_id: documents.id
            }).then(function (response) {
              window.open('/reports/summary-report/' + response.data.summary_id);
            });
          } else {
            window.open('/reports/summary-report/' + documents.summaries[0].summary_id);
          }
        }
      },
      evaluateSummaryById(summaryId) {
        window.open('/reports/summary-report/' + summaryId);
      },
      evaluateSummaryGrid(documents) {
        if (documents) {
          SummaryService.createSummaryGrid({
            summary_id: documents.summaries[0].id
          }).then(function (response) {
            console.log('Grid data: ', response);
            window.open('/reports/evaluation-grid/' + response.data.grid_id);
          });
        }
      },
      evaluationGridSummary(summaryId) {
        window.open('/reports/evaluation-grid/' + summaryId);
      },
      exportFinalRanking()
      {
        let vm = this;
        let loader = vm.$loading.show();

        DocumentService.exportFinalRanking({
          region_id: this.filters.regionId
        }).then(function (response)
        {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }

          loader.hide();
        });
      },
      downloadEvaluations()
      {
        SummaryService.createEvaluationsPDF({
            region_id: this.filters.regionId
        }).then(function (response)
        {
          if (response.data && response.data.success)
          {
            window.open(response.data.url, '_blank');
          }
          else
          {
            alert('There are no PDFs uploaded on the selected region');
          }
        });
      },
      changeEvaluationStatus()
      {
        let vm = this;

        if (confirm('Are you sure you want to change evaluation status?'))
        {
          let documents = vm.modalEvaluate.documents;

          SummaryService.updateEvaluationStatus(
            documents.summaries[0].id,
            {
              evaluation_status: documents.evaluation_status
            }
          ).then(function (response)
          {
          });
        }
      },
      async getDocuments() {
        let vm = this;
        return await DocumentService.getDocuments(vm.filters).then(function (response) {
          vm.tableData = response.data;
        })
      },
      async handleFilters() {
        let vm = this;
        let loader = vm.$loading.show();
        await vm.getDocuments();
        await vm.getFilters();
        loader.hide();
      },
      async getFilters() {
        let vm = this;
        return await DocumentService.getDocumentsFilters({
          filter_application_status: vm.filters.applicationStatus,
          filter_region_id: vm.filters.regionId,
          filter_objectives: vm.filters.objectives,
        }).then((response) => {
          vm.filterOptions = response.data;
        })
      },
      initFuse() {
        this.fuseSearch = new Fuse(this.tableData, {
          keys: this.propsToSearch,
          threshold: 0.3
        });
      },
    },
    async mounted() {
      let vm = this;
      let loader = vm.$loading.show();

      vm.loggedUser = vm.$store.getters['Auth/loggedUser'];

      await vm.getItems();

      await vm.getDocuments();
      await vm.getFilters();
      vm.initFuse();
      loader.hide();

    },
    watch: {
      /**
       * Searches through the table data by a given query.
       * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
       * @param value of the query
       */
      searchQuery(value) {
        let result = this.tableData;
        if (value !== '') {
          result = this.fuseSearch.search(this.searchQuery);
        }
        this.searchedData = result;
      }
    }
  };
</script>
